module.exports = __webpack_public_path__ + "img/greevil_whistle.f42e6f0a.png";